import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2a5d7732&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsBreadcrumbs: require('/var/web/bet777.es/components/elements/breadcrumbs.vue').default,OutrightsWidget: require('/var/web/bet777.es/components/outrights-widget.vue').default})
